import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-ribbon',
  templateUrl: './ribbon.component.html',
  styleUrls: ['./ribbon.component.scss']
})
export class RibbonComponent implements OnInit {

  color:any;
  toggle = false
  tag:any;
  ribbonForm: FormGroup
  public tags: any[] = [{
    tag: '',
  }];

  constructor() { }

  ngOnInit(): void {
  }

  addRibbon(){

  }

  addAddress() {
    this.tags.push({
      tag: '',
    });
    console.log(this.tags)
  }

  changedColor(event){
    console.log(event)
  }
}
